import { Component, input, output } from '@angular/core';

@Component({
  selector: 'eiq-action-menu-item',
  templateUrl: './action-menu-item.component.html',
  styleUrls: ['./action-menu-item.component.scss']
})
export class ActionMenuItemComponent {
  testId = input<string>();

  clicked = output<void>();
}
